import { LogOut, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/cards';
import { useAuth } from '@/providers/authProvider';
import { useUser } from '@/providers/userProvider';

export const NoAccess = () => {
  const { logout } = useAuth();
  const { user } = useUser();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-6">
      <Card className="max-w-md w-full p-8">
        <div className="flex justify-center mb-6">
          <img src="/logo.png" alt="Martcart" className="h-10" />
        </div>
        <h1 className="text-xl font-semibold text-center mb-3">
          Your account isn&apos;t set up yet
        </h1>
        <p className="text-sm text-muted-foreground text-center mb-6">
          You&apos;re signed in as{' '}
          <span className="font-medium text-base-foreground">{user?.email}</span>, but your
          account doesn&apos;t have portal access assigned. Please contact Martcart
          Zeosphere Support to be set up.
        </p>
        <div className="flex items-center justify-center gap-2 mb-6 text-sm">
          <Mail className="w-4 h-4 text-muted-foreground" />
          <a
            href="mailto:support@martcart.com"
            className="text-blue-600 hover:underline"
          >
            support@martcart.com
          </a>
        </div>
        <Button variant="outline" className="w-full" onClick={logout}>
          <LogOut className="w-4 h-4 mr-2" />
          Sign out
        </Button>
      </Card>
    </div>
  );
};
